import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faArrowRight,
  faShieldAlt,
  faCheck,
  faMobile,
  faShoppingCart,
  faCreditCard,
  faSearch,
  faEye,
  faEyeSlash,
  faCrown,
  faArrowCircleDown,
  faDownload,
  faServer,
  faUserTag,
  faPercentage,
  faHeadphones,
  faTable,
  faLaptop,
  faHome,
  faBars,
  faUserCircle,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt,
  faToggleOn,
  faToggleOff,
  faSun,
  faMoon,
  faCircleHalfStroke,
  faCog,
  faSync,
  faChartLine,
  faUsers,
  faBolt,
  faClock,
  faTriangleExclamation,
  faLock,
  faChartColumn,
  faChartPie,
  faEnvelope,
  faArrowLeft,
  faGlobe,
  faPhone,
} from '@fortawesome/free-solid-svg-icons'

import {
  faInstagram,
  faYoutube,
  faTwitter,
  faFacebook,
  faAmazonPay,
  faApplePay,
  faGooglePay,
  faCcStripe,
  faApple,
  faWindows,
  faAndroid,
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faArrowRight,
  faToggleOff,
  faToggleOn,
  faShieldAlt,
  faCheck,
  faInstagram,
  faYoutube,
  faTwitter,
  faFacebook,
  faMobile,
  faAmazonPay,
  faShoppingCart,
  faApplePay,
  faGooglePay,
  faCreditCard,
  faCcStripe,
  faSearch,
  faAndroid,
  faWindows,
  faApple,
  faEye,
  faEyeSlash,
  faCrown,
  faArrowCircleDown,
  faDownload,
  faServer,
  faUserTag,
  faPercentage,
  faHeadphones,
  faTable,
  faLaptop,
  faHome,
  faBars,
  faUserCircle,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt,
  faSun,
  faMoon,
  faCircleHalfStroke,
  faCog,
  faSync,
  faChartLine,
  faUsers,
  faBolt,
  faClock,
  faTriangleExclamation,
  faLock,
  faChartColumn,
  faChartPie,
  faEnvelope,
  faArrowLeft,
  faGlobe,
  faPhone
)

export { FontAwesomeIcon }
